module.exports = __webpack_public_path__ + "media/images/requisitions/close-1cc7b14e68cd13d7661a0fa6893f975c.png";